import React from 'react';
import { Button } from '../../shared';
import './loan-purpose.scss';
export var LoanPurpose = function (_a) {
    var loanPurposeList = _a.loanPurposeList, setLoanPurpose = _a.setLoanPurpose;
    return (React.createElement("ul", { className: "c-loan-purpose" }, loanPurposeList.map(function (item) { return (React.createElement("li", { key: item.id, className: "c-loan-purpose__item" },
        React.createElement("span", { className: "c-loan-purpose__value" }, item.value),
        React.createElement(Button, { type: "button", variant: "primary", dataValue: item.id, onClick: setLoanPurpose }, "Select"))); })));
};
